import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/tailwind.css';
import './styles/tokens.css';
import './styles/app.css';
import './i18n';
import App from './App';
import { PlayerProvider } from './player/PlayerContext';

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root not found — index.html 有問題');
}

/**
 * PWA：註冊 Service Worker（**只喺生產**，避免 dev 時 cache 干擾）。
 * ⚠️ SW 一律唔 cache `/api/*`（見 `public/sw.js` 鐵律）→ 對話／歌曲狀態永遠即時。
 */
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /** 註冊失敗唔應該影響 app 使用（只係冇得裝落主畫面） */
    });
  });
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      {/* 全 app 單一播放器（離開頁面都繼續播；見 `src/player/PlayerContext.tsx`） */}
      <PlayerProvider>
        <App />
      </PlayerProvider>
    </BrowserRouter>
  </StrictMode>,
);
